import store from '@/store'
import { loadMicroApp } from 'qiankun'
import { initialState } from '../shared/qiankun_actions.js'

console.log('开始测试： 11111111111')

/**
 * @description 查找当前页签是否是微应用下的页面
 */
export function isMicroApp(path) {
  return !!store.state.currentMicroApps.some((item) => {
    return path.startsWith(item.activeRule)
  })
}
/**
 * @description 查找当前页签是否是微应用下的页面，并返回对应微应用配置项
 */
export function findMicroAppByPath(path) {
  return store.state.currentMicroApps.find((item) => {
    return '/' + path.split('/')[1] === item.activeRule
  })
}

function isShow(routePath) {
  if (!routePath.startsWith('http')) {
    return false
  }
  const isHttps = routePath.startsWith('https')
  const re = /^http(s)?:\/(\/)?/
  const realRoutePath = routePath.replace(re, isHttps ? 'https://' : 'http://')
  return realRoutePath
}
/**
 * @description 创建微应用
 */
export function createMicroApp(page) {
  return new Promise((resolve, reject) => {
    let realExternalAppPath = false
    console.log(page, 'path测试')
    const loadedMicroApps = {
      ...store.state.loadedMicroApps,
    } // 已手动挂载的微应用对象
    if (page.fullpath) {
      realExternalAppPath = isShow(page.fullpath.slice(1))
      if (realExternalAppPath) {
        const externalApps = store.state.loadExternalApps
        const getPurePath = (path) =>
          path ? path.split('?')[0].split('#')[0] : ''
        const isExist = externalApps.find(
          (app) => getPurePath(app.pageUrl) === getPurePath(realExternalAppPath)
        )
        if (isExist) {
          resolve()
          return
        }
        externalApps.push({
          ...page,
          pageUrl: realExternalAppPath,
        })
        store.dispatch('setExternalApp', externalApps)
        resolve()
        return
      }
    }
    const currentOrgApps = store.state.appsInOrg
    const isExternalApp = !(
      currentOrgApps.find(
        (app) =>
          app.appName === page.applicationName && app.microFrontFlag === '1'
      ) ||
      (page.microFrontFlag === '1' && page.dev === true)
    )
    console.log(currentOrgApps, isExternalApp, page.applicationName, '测试')
    if (isExternalApp) {
      const externalApps = store.state.loadExternalApps
      const isExist = externalApps.find((app) => app.pageUrl === page.pageUrl)
      if (isExist) {
        resolve()
        return
      }
      externalApps.push(page)
      store.dispatch('setExternalApp', externalApps)
      resolve()
      return
    }
    if (
      !(
        isMicroApp(page.path || page.pageUrl) ||
        (page.microFrontFlag === '1' && page.dev === true)
      )
    ) {
      // 非微应用直接跳转
      resolve()
      return
    }

    // 微应用跳转处理
    /**
     * @description 1.判断是否已手动加载，是则直接跳转，否则先手动挂载，再跳转
     */
    let microAppResult
    if (page.dev && page.microFrontFlag === '1') {
      microAppResult = page
    } else {
      microAppResult = findMicroAppByPath(page.path || page.pageUrl) // 是否是微应用的跳转
    }
    if (
      Object.prototype.hasOwnProperty.call(loadedMicroApps, microAppResult.name)
    ) {
      resolve()
      return
    }
    try {
      console.log(store.state, 'store state')
      // 主应用数据通过props传递给微应用（首次加载）
      console.log(microAppResult, '测试数据，哈哈哈哈')
      loadedMicroApps[microAppResult.name] = loadMicroApp(
        {
          ...microAppResult,
          props: {
            ...initialState,
            app: {
              ...initialState.app,
              appName: microAppResult.appName,
              microFrontFlag: microAppResult.microFrontFlag,
              uiUrl: microAppResult.uiUri,
              sevUrl: microAppResult.uiUri,
            },
          },
        },
        {
          // 隔离样式，还是给各个应用一个唯一的根id，然后包裹起来
          // qiankun的样式隔离选项不靠谱，会存在一些隐藏的bug，比如eleemntui弹框选择组件就有问题
          // sandbox: {
          //     strictStyleIsolation: true,
          //     experimentalStyleIsolation: true
          // }
        }
      ) // 加载微应用
      store.dispatch('setLoadedMicroApps', loadedMicroApps)
      // console.log('挂载后的已挂载的微应用==>', store.state.loadedMicroApps)
      resolve()
    } catch (err) {
      reject(err)
      console.log(err)
    }
  })
}
